import React, { useEffect } from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import braceletsImg from '../assets/braceletsHori.jpg';

import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '6.25rem'
  },
  textCont: {
    width: '51%',
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  },
  imgCont: {
    width: '51%',
    flexWrap: 'nowrap',
    marginBottom: '2.2rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexWrap: 'wrap'
    }
  },
  imgCap: {
    width: '100%',
    marginTop: '1rem',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      width: '75%',
      marginTop: '1rem',
      textAlign: 'center'
    }
  },
  sectionTitle: {
    width: '81%',
    marginTop: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  textWImg: {
    flexWrap: 'nowrap'
  }
}));

const CervicalCancer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView();
  const animation = useAnimation();

  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,
        transition: {
          type: 'spring',
          duration: 6
        }
      });
    }
    if (!inView) {
      animation.start({ opacity: 0 });
    }
  }, [inView, animation]);

  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className={classes.container}
      >
        <Grid
          ref={ref}
          container
          direction="column"
          alignItems={matchesSM ? 'center' : 'flex-start'}
          className={classes.imgCont}
        >
          <motion.img
            animate={animation}
            src={braceletsImg}
            alt="hospital bracelets"
            style={{ width: '100%' }}
          />
          <Typography variant="caption" className={classes.imgCap}>
            Patti Murillo-Casa's collection of hospital bracelets, that she ammassed during
            treatment.
          </Typography>
        </Grid>
        <Grid container item direction="row" className={classes.textCont}>
          <Typography variant="h2" className={classes.sectionTitle}>
            What is Cervical Cancer & How is it Typically Treated?
          </Typography>

          <Grid container className={classes.paragraphs}>
            <Typography variant="body1" style={{ marginTop: '1.75rem' }}>
              Cervical cancer occurs when normal cells in the cervix (the bottom part of the uterus)
              evolve into abnormal cells and grow uncontrollably. Women may not experience initial
              symptoms, but when they do, signs include vaginal bleeding occurring in between
              menstrual cycles, after sex, and after menopause, as well as pelvic pain or pain
              during intercourse.
            </Typography>
            <Typography varaint="body1" style={{ marginTop: '1.75rem' }}>
              A Pap test is conducted during a routine physical with a general practitioner or with
              an OB-GYN to screen for cervical cancer. Doctors can also test for the human
              papillomavirus (HPV), a cervical cancer-causing virus that’s sexually transmitted
              through skin to skin contact. The body’s immune system usually prevents the virus from
              doing harm when it’s been exposed to HPV, but the virus can survive in the body for
              years, contributing to the process that causes some cervical cells to change into
              cancer cells.
            </Typography>
            <Typography varaint="body1" style={{ marginTop: '1.75rem' }}>
              If the test results are abnormal, a biopsy will follow. Sometimes the doctor will find
              precancerous cells—abnormal cells that have a high chance of turning into cancer.
              Treatment for cervical cancer includes surgery (removing all or part of the cervix and
              in some cases, a hysterectomy), radiation therapy, and chemotherapy. HPV vaccines and
              treating precancerous cells once detected are proactive measures women can take to
              prevent cervical cancer.
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CervicalCancer;
